/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Locked_LabelInputs */

const en_explorer_info_locked_label = /** @type {(inputs: Explorer_Info_Locked_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locked`)
};

const fr_explorer_info_locked_label = /** @type {(inputs: Explorer_Info_Locked_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrouille`)
};

const de_explorer_info_locked_label = /** @type {(inputs: Explorer_Info_Locked_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesperrt`)
};

const it_explorer_info_locked_label = /** @type {(inputs: Explorer_Info_Locked_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloccato`)
};

const ru_explorer_info_locked_label = /** @type {(inputs: Explorer_Info_Locked_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заблокировано`)
};

const es_explorer_info_locked_label = /** @type {(inputs: Explorer_Info_Locked_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueado`)
};

const zh_cn2_explorer_info_locked_label = /** @type {(inputs: Explorer_Info_Locked_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已锁定`)
};

const ja_explorer_info_locked_label = /** @type {(inputs: Explorer_Info_Locked_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロックされています`)
};

const hi_explorer_info_locked_label = /** @type {(inputs: Explorer_Info_Locked_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद`)
};

const pt_pt2_explorer_info_locked_label = /** @type {(inputs: Explorer_Info_Locked_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trancado`)
};

/**
* | output |
* | --- |
* | "Locked" |
*
* @param {Explorer_Info_Locked_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_locked_label = /** @type {((inputs?: Explorer_Info_Locked_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Locked_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_locked_label(inputs)
	if (locale === "de") return de_explorer_info_locked_label(inputs)
	if (locale === "it") return it_explorer_info_locked_label(inputs)
	if (locale === "ru") return ru_explorer_info_locked_label(inputs)
	if (locale === "es") return es_explorer_info_locked_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_locked_label(inputs)
	if (locale === "ja") return ja_explorer_info_locked_label(inputs)
	if (locale === "hi") return hi_explorer_info_locked_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_locked_label(inputs)
	return en_explorer_info_locked_label(inputs)
});